import { columnSummary } from "../pages/DataSet/StatisticsTable.tsx";
import { datasetService } from "../Services/DataListService.ts";

export const handleFetchDatasets = async (skip = 0, limit = 10, page = 1): Promise<any> => {
  try {
    const response = await datasetService.fetchDatasets(skip, limit, page);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching dataset list:", error);
    throw new Error("Failed to fetch datasets");
  }
};
export const handleFetchValidDatasets = async (): Promise<any> => {
  try {
    const response = await datasetService.fetchValidDatasets();
    return response.data;
  } catch (error: any) {
    console.error("Error fetching dataset list:", error);
    throw new Error("Failed to fetch datasets");
  }
};
export const handleFetchPredictionDatasets = async (dataset_id): Promise<any> => {
  try {
    const response = await datasetService.fetchPredictionDatasets(dataset_id);
    return response.data;
  }catch (error: any) {
    console.error("Error fetching prediction dataset list:", error);
    throw new Error("Failed to fetch prediction datasets");
  }
}
export const handleDeleteDataset = async (datasetId: number): Promise<void> => {
  try {
    await datasetService.deleteDataset(datasetId);
  } catch (error: any) {
    console.error("Error deleting dataset:", error);
    throw new Error(error.response?.data?.detail || "Failed to delete dataset");
  }
};

export const handleDownloadError = async (filePath): Promise<any> => {
  try {
    const response = await datasetService.DownloadError(filePath);
    return response.data;
  } catch (error: any) {
    console.error("Error fdownl", error);
    throw error;
  }
};
export const handleFetchDatasetView = async (dataset_id: number): Promise<any> => {
  try {
    const response = await datasetService.fetchDataSetView(dataset_id);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching file view:", error);
  }
};

export const generateStatistics = async (dataset_id): Promise<any> => {
  try{
    const response = await datasetService.generateStatistics(dataset_id);
    return response.data;
  }catch (error: any){
    console.error("Error generating statistics:", error);
    throw new Error(error.response?.data?.detail || "Failed to generate dataset statistics");
  }
}

export const fetchStatistics = async (dataset_id): Promise<any> => {
  try{
    const response = await datasetService.fetchStatistics(dataset_id);
    return response.data;
  }catch (error: any){
    console.error("Error generating statistics:", error);
    throw new Error(error.response?.data?.detail || "Failed to generate dataset statistics");
  }
}

export const fetchColumnSummary = async (payload): Promise<columnSummary> => {
  try{
    const response = await datasetService.fetchSummary(payload);
    return response.data;
  }catch (error: any){
    console.error("Error generating Column summary:", error);
    throw new Error(error.response?.data?.detail || "Failed to generate Column Summary");
  }
}

export const fetchDataSource = async (): Promise<any> => {
  try{
    const response = await datasetService.getDatasource();
    return response.data;
  }catch (error: any){
    console.error("Error generating statistics:", error);
    throw new Error(error.response?.data?.detail || "Failed to generate dataset statistics");
  }
}

